import React, { useEffect } from 'react'

import { Spinner } from '@wartek-id/spinner'

import { NotFoundError } from 'utils/customError'

export function PageGuardKinerjaHarianV2({
  children,
  isActive = false,
  isPerencanaanReady = false,
  isLoading = false,
}: {
  children: React.ReactNode
  isActive?: boolean
  isPerencanaanReady?: boolean
  isLoading?: boolean
}) {
  useEffect(() => {
    if (!isLoading && !(isActive && isPerencanaanReady)) {
      throw new NotFoundError('', null)
    }
  }, [isActive, isPerencanaanReady, isLoading])

  if (isLoading) {
    return (
      <div className="flex p-10">
        <div className="m-auto">
          <Spinner />
        </div>
      </div>
    )
  }

  return <>{children}</>
}
